import styled, { css } from 'styled-components';
import { TOOLBAR_HEIGHT } from 'components/AppToolbar/styles';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

const {
  SPACING
} = Tokens;

const styles = {
  MultiSelectToolbar: styled.div`
    min-height: ${TOOLBAR_HEIGHT};
    width: 100%;
    ${props =>
    props.$RTL &&
      css`
        direction: rtl;
      `}
    ${props =>
    props.$variant === 'floating' &&
      css`
        position: absolute;
        top: 0;
        [class^=styles__AppToolbar-] {
          box-shadow: none;
        }
      `}
  `,
  MultiSelectToolbarDivider: styled.div`
    margin: 0 ${SPACING.SPACING_24};
    height: 2.25rem;
    background: ${props => props.$theme.color};
    width: 0.0625rem; //1px
  `,
  MultiSelectToolbarLeft: styled.div`
    display: flex;
    align-items: center;
    margin: 0 ${SPACING.SPACING_24};
  `,
  MultiSelectToolbarRight: styled.div`
    margin: 0 ${SPACING.SPACING_16};
    display: flex;
    align-items: center;
  `
};

export default styles;
